// 👤 Edusense User 도메인 전용 클라이언트
// 완전 독립적인 User API 클라이언트 (deprecated edusense-client 사용 안함)

// 생성된 User API와 타입만 export (레거시 수동 코드 제거)
// Orval/Codegen 산출물에 100% 의존
// 기본적으로 생성물의 index를 통해 전체 API를 노출합니다.
export * from './client_gen_gen_generated/profile';
export * from './client_gen_gen_generated/search';
export * from './client_gen_gen_generated/stats';
export * from './client_gen_gen_generated/users';
export * from './client_gen_gen_generated/types';
